import {AnalyticsBrowser} from '@segment/analytics-next';
import {ANALYTICS_EVENTS} from './constants';
import {IS_PROD_ENV} from '../constants';
import {IdentifyOptions, Traits, TrackProperties} from './types';

class AnalyticsService {
    private isEventsTracked: boolean = true;

    private traits: Traits = {};

    private analytics: AnalyticsBrowser = new AnalyticsBrowser();

    load = (writeKey: string) => this.analytics.load({writeKey});

    identify = (userId: number | string | undefined, traits: Traits, options?: IdentifyOptions) => {
        const {isEventsTracked = true} = options ?? {};
        this.isEventsTracked = !IS_PROD_ENV || isEventsTracked;

        if (!this.isEventsTracked) {
            return;
        }

        this.traits = traits;
        this.analytics.identify(String(userId), traits);
    };

    reset = () => {
        this.analytics.reset();
        this.traits = {};
        this.isEventsTracked = true;
    };

    track = (eventName: string, properties = {}, callback?: Function | undefined) => {
        if (!this.isEventsTracked) {
            return;
        }

        this.analytics.track(eventName, {...properties, ...this.traits}, callback);
    };
}

export default new AnalyticsService();
export type {TrackProperties};
export {ANALYTICS_EVENTS};
